// components/logo.tsx
export function Logo() {
  return (
    <>
      <img src="/logo-light.png" className="h-6 w-6 dark:hidden" />
      <img src="/logo-dark.png" className="hidden h-6 w-6 dark:block" />
    </>
  );
}
